import { CampaignDetails } from "@/lib/types";
import { getPlayer, getPlayerCampaign } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { AssignedPlayersRenderer } from "@/pages/player/shared/AssignedPlayersRenderer";
import { LoadingSmall } from "@/components/LoadingSmall";

interface Props {
  campaignDetails: CampaignDetails;
}

export const CampaignDetailAssignedPlayers = ({ campaignDetails }: Props) => {
  const activeFirm = useSelector(selectActiveFirm);

  const { data: playerCampaignsAll, isLoading } = useQuery({
    queryFn: async () => {
      const data = [];
      const players =
        (
          await getPlayer(
            {
              numberOfObjectsPerPage: 999999,
              pageNumber: 1,
            },
            {
              Firm_Id: String(activeFirm?.firmGuid),
            }
          )
        ).data.result || [];

      for (const player of players) {
        const playerCampaigns = await getPlayerCampaign(player.id, String(activeFirm?.firmGuid));

        data.push({
          player,
          campaigns: playerCampaigns.data.result,
        });
      }

      return data;
    },
    queryKey: ["campaignPlayers", campaignDetails.id],
  });

  const players = (playerCampaignsAll || [])
    ?.filter((player) => player.campaigns.some((campaign) => campaign.campaignId === campaignDetails.id))
    .map((r) => r.player);

  if (isLoading) {
    return <LoadingSmall />;
  }

  return <AssignedPlayersRenderer players={players} />;
};
